import ToggleButton from "../../../../../Components/common/ToggleButton/ToggleButton";

const NotificationHeader = ({
  selectedNotification,
  toggleProps = { show: false, text: "", active: false, onClick: () => {} },
  note,
}) => {
  return (
    <div className="notifications-body-header">
      <h3 className="notifications-body-header__title">{selectedNotification}</h3>
      {toggleProps.show ? (
        <div className="notifications-body-header__auto-update">
          <span>{toggleProps.text}</span>
          <ToggleButton active={toggleProps.active} onClick={toggleProps.onClick} />
        </div>
      ) : null}
      {note ? (
        <p className="notifications-body-header__description">
          <span> NOTE:</span> {note}
        </p>
      ) : null}
    </div>
  );
};

export default NotificationHeader;
